import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.managementService


// 根据角色 rid 返回该角色拥有的菜单id数组
export function getSelectModuleIdByRoleId(data) {
    return request({
        url: serviceName + `/menu/tree?roleId=${data}`,
        method: 'get',
    })
}

// 修改角色拥有的菜单id数组
export function getUpdateFunctionByRoleId(data) {
    return request({
        url: serviceName + `/menu/state`,
        method: 'post',
        data: data
    })
}

//所有菜单列表 state
export function getAllMenuList(data) {
    return request({
        url: serviceName + `/menu/list`,
        method: 'get',
    })
}